import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "contract"
};
import { onMounted, ref } from "vue";
import ContractList from './ContractList';
import apis from "@/api";
import { ElMessage } from "element-plus";
export default {
  __name: 'Index',
  setup(__props) {
    const activeTab = ref("contract");
    const isAdmin = ref(true);
    const elLoading = ref(false);
    onMounted(() => {
      queryIsAdmin();
    });
    const queryIsAdmin = () => {
      elLoading.value = true;
      apis.queryUserIsAdmin().then(res => {
        if (res.success) {
          isAdmin.value = res.data;
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        elLoading.value = false;
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(ContractList), {
        "is-admin": isAdmin.value
      }, null, 8, ["is-admin"])]);
    };
  }
};